var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { transform: "translate(2 2)", fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { stroke: "#EAEAEA", strokeWidth: "2.4", fill: "#FFF", fillRule: "nonzero", cx: "13", cy: "13", r: "13" }),
      React.createElement("path", { d: "M12 16.54c.013-1.08.17-1.937.47-2.57.3-.633.843-1.297 1.63-1.99.413-.373.7-.637.86-.79.16-.153.333-.41.52-.77.187-.36.28-.74.28-1.14 0-.68-.24-1.25-.72-1.71-.48-.46-1.14-.69-1.98-.69-1 0-1.757.303-2.27.91-.513.607-.783 1.443-.81 2.51H8.34c.027-1.453.433-2.627 1.22-3.52.787-.893 1.973-1.34 3.56-1.34 1.36 0 2.427.363 3.2 1.09.773.727 1.16 1.637 1.16 2.73 0 .747-.163 1.373-.49 1.88-.327.507-.777 1-1.35 1.48-.88.733-1.45 1.327-1.71 1.78-.26.453-.397 1.167-.41 2.14H12zM11.78 20v-1.98h1.94V20h-1.94z", stroke: "#EAEAEA", strokeWidth: ".8", fill: "#EAEAEA" }),
      React.createElement("path", { fill: "#FFF", d: "M10 17h5v4h-5z" }),
      React.createElement("path", { fill: "#EAEAEA", d: "M11.5 18H14v2.5h-2.5z" })
    )
  );
});